<app-inscription-feeds></app-inscription-feeds>
